import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { seoHead } from '@/lib/seoHead';
import { comparisonQuery } from '@/components/comparison/ComparisonPages';
import { ComparisonIndex } from '@/components/comparison/ComparisonPages';
import { ComparisonError } from '@/components/comparison/ComparisonError';

const optionalQueryText = z.preprocess((value) => value == null ? undefined : String(value), z.string().max(80).optional());
const schema = z.object({ q: optionalQueryText, category: optionalQueryText, brand: optionalQueryText, page: z.coerce.number().int().min(0).max(100).optional(), min: z.coerce.number().min(0).optional(), max: z.coerce.number().min(0).optional() });
export const Route = createFileRoute('/comparador-de-precos/')({
  validateSearch: schema,
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps }) => context.queryClient.ensureQueryData(comparisonQuery(deps)),
  head: ({ loaderData }) => seoHead({ title: 'Comparador de Preços | Shopping do Bem', description: 'Compare o preço à vista do mesmo produto em lojas parceiras e escolha com transparência.', path: '/comparador-de-precos', noindex: !loaderData?.items.length, ogImage: null }),
  component: () => <ComparisonIndex search={Route.useSearch()} />,
  errorComponent: ({ reset }) => <ComparisonError reset={reset} />,
});